.picture {
  display: block;
  overflow: hidden;
  line-height: 0;
}

.image {
  width: 100%;
  height: auto;
  display: block;
}
